import React from 'react';

import cx from 'classnames';
import getColourPropsByColourSchemaAndCampaignColor from 'utils/getColourPropsByColourSchemaAndCampaignColor';

import DynamicHeadingLine from 'components/DynamicHeadingLine/DynamicHeadingLine';
import FullWidthContent from 'components/FullWidthContent/FullWidthContent';
import LinkButtonRow from 'components/LinkButtonRow/LinkButtonRow';
import RowWithOffsetCol from 'components/RowWithOffsetCol/RowWithOffsetCol';
import { ICampaignContent } from 'models/campaignContent';

interface IProps {
  campaignContent: ICampaignContent;
  colour: string;
}
const FullWidthCampaignContent: React.FC<IProps> = ({
  campaignContent,
  colour,
}) => {
  const { backgroundColor, btnVariant, headingColor, textColorClass } =
    getColourPropsByColourSchemaAndCampaignColor(
      colour,
      campaignContent.colour_schema?.name,
    );
  return (
    <>
      {campaignContent.heading && (
        <RowWithOffsetCol>
          <div className="full-width-title-container no-pointer-events">
            <h1 data-content="campaign_content_heading" className="text-left">
              {campaignContent.heading}
            </h1>
            <DynamicHeadingLine
              className={cx({
                'mb-0':
                  !campaignContent.content_media &&
                  !campaignContent.content_brief &&
                  !campaignContent.sub_heading,
              })}
              colour={headingColor}
            />
          </div>
        </RowWithOffsetCol>
      )}

      {!!campaignContent.content_media && (
        <FullWidthContent
          style={{ backgroundColor }}
          videoPlayerProps={{
            className: 'rounded-none rounded-sm-md',
          }}
          className={cx(
            'mx-n3 rounded-none rounded-sm-md mx-md-0 flex-grow-1',
            textColorClass,
            {
              'mb-5':
                !!campaignContent.content_brief ||
                !!campaignContent.sub_heading,
            },
          )}
          media={campaignContent.content_media}
          mediaAlt={campaignContent.content_media_alt}
          transcript={campaignContent.transcript}
        />
      )}
      {(!!campaignContent.content_brief || !!campaignContent.sub_heading) && (
        <RowWithOffsetCol>
          <div className="px-3 px-md-4 px-md-0">
            {campaignContent.sub_heading && (
              <h4
                data-content="campaign_content_heading"
                className="campaign-homepage-heading text-bold mb-3"
              >
                {campaignContent.sub_heading}
              </h4>
            )}
            {campaignContent.content_brief && (
              <div
                className="text-left"
                data-content="campaign_content_content_brief"
                dangerouslySetInnerHTML={{
                  __html: campaignContent.content_brief,
                }}
              />
            )}
            <LinkButtonRow
              btnProps={{ variant: btnVariant }}
              links={campaignContent.links || []}
            />
          </div>
        </RowWithOffsetCol>
      )}
    </>
  );
};

export default FullWidthCampaignContent;
